import { Flex, VStack } from '@chakra-ui/react';
import { useTheme } from '@/contexts/ThemeProvider';

export function TermsOfUse() {
  const { legalText } = useTheme();

  if (legalText)
    return (
      <Flex width={'100%'} className="legal" paddingBottom={10}>
        <p style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: legalText }}></p>
      </Flex>
    );

  return (
    <Flex className="legal" paddingBottom={10}>
      <VStack alignItems="flex-start" spacing={3} width="100%">
        <h2>Termos de Uso e Condições Gerais de Utilização</h2>

        <h3>Cláusula I – Objeto</h3>
        <p>
          O presente instrumento tem por objeto estabelecer os termos e condições de utilização da plataforma digital
          disponibilizada pela PARTIU TECNOLOGIA E EDITORA ISPs LTDA e demais empresas do grupo, destinada à distribuição,
          disponibilização e acesso a obras editoriais digitais, incluindo, mas não se limitando a:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>ebooks</li>
          <li>audiobooks</li>
          <li>revistas digitais</li>
          <li>próprias ou de terceiros, devidamente identificadas por ISBN e/ou ISSN, conforme aplicável.</li>
        </ul>
        <p>
          A plataforma digital atua exclusivamente como meio tecnológico para organização, disponibilização e acesso às
          referidas obras, não se caracterizando como prestação de serviço de conteúdo sob demanda, streaming ou intermediação.
        </p>
        <p>
          A plataforma poderá ainda integrar, de forma acessória, funcionalidades adicionais disponibilizadas por empresas
          clientes ou parceiras, incluindo, mas não se limitando a:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>áreas de relacionamento com o usuário</li>
          <li>central do cliente</li>
          <li>funcionalidades administrativas (ex: segunda via de faturas)</li>
          <li>integrações com sistemas de terceiros (ERP, CRM e similares)</li>
          <li>acesso a serviços digitais contratados junto a terceiros</li>
        </ul>
        <p>
          Tais funcionalidades possuem caráter meramente instrumental e acessório, não constituindo o objeto principal da
          relação, que permanece sendo a disponibilização de obras editoriais.
        </p>

        <h3>Cláusula II – Cadastro e Acesso</h3>
        <p>
          Para acesso à plataforma, o usuário deverá realizar cadastro com informações verídicas e atualizadas.
        </p>
        <p>
          O acesso do usuário está vinculado à disponibilização de obras editoriais adquiridas direta ou indiretamente
          por meio de contratos com empresas clientes da PARTIU ou por aquisição direta.
        </p>
        <p>
          A PARTIU poderá, a seu critério, solicitar validações adicionais para garantir a autenticidade das informações,
          bem como suspender ou cancelar acessos em caso de inconsistências ou uso indevido.
        </p>

        <h3>Cláusula III – Natureza das Obras Digitais</h3>
        <p>As obras digitais disponibilizadas ao usuário:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>são obras editoriais protegidas por direitos autorais</li>
          <li>possuem identificação por ISBN (livros) ou ISSN (revistas), quando aplicável</li>
          <li>são fornecidas mediante cessão de cópia digital</li>
        </ul>
        <p>Nos casos aplicáveis, o usuário poderá:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>realizar download da obra</li>
          <li>armazenar em dispositivos próprios</li>
          <li>acessar em plataformas externas compatíveis</li>
        </ul>
        <p>
          Caracterizando, assim, a disponibilização para uso permanente, nos termos contratuais.
        </p>

        <h3>Cláusula IV – Formas de Acesso às Obras</h3>
        <p>As obras poderão ser disponibilizadas nas seguintes modalidades:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>download da obra digital (ebook)</li>
          <li>download de versão em áudio (audiobook), quando disponível</li>
          <li>envio para e-mail</li>
          <li>leitura online na plataforma</li>
          <li>reprodução em áudio na plataforma (quando aplicável)</li>
        </ul>
        <p>
          A disponibilização para leitura ou reprodução online constitui facilidade de acesso, não alterando a natureza
          da cessão da obra.
        </p>

        <h3>Cláusula V – Plataforma Tecnológica</h3>
        <p>A plataforma disponibilizada pela PARTIU:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>não constitui serviço de streaming</li>
          <li>não configura assinatura de conteúdo ilimitado</li>
          <li>não representa cessão de acesso irrestrito a acervo</li>
        </ul>
        <p>Sua função é exclusivamente:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>organizar, disponibilizar e permitir o acesso às obras editoriais adquiridas.</li>
        </ul>

        <h3>Cláusula VI – Direitos Autorais</h3>
        <p>
          Todos os direitos relativos às obras editoriais pertencem aos respectivos autores e/ou editoras.
        </p>
        <p>O usuário não poderá:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>reproduzir para fins comerciais</li>
          <li>redistribuir</li>
          <li>compartilhar de forma indevida</li>
        </ul>
        <p>
          sob pena de responsabilização civil e criminal.
        </p>

        <h3>Cláusula VII – Benefícios e Conteúdos Acessórios</h3>
        <p>
          Eventuais benefícios, descontos ou vantagens disponibilizados ao usuário decorrem de informações contidas em
          conteúdos editoriais, incluindo revistas digitais, podendo estar sujeitos a condições específicas definidas
          por terceiros.
        </p>
        <p>
          Tais benefícios possuem caráter acessório e informativo, não constituindo o objeto principal da relação contratual.
        </p>

        <h3>Cláusula VIII – Limitação de Responsabilidade</h3>
        <p>
          A PARTIU não garante disponibilidade ininterrupta da plataforma, podendo ocorrer interrupções por motivos
          técnicos, operacionais ou de conectividade.
        </p>
        <p>
          A responsabilidade da PARTIU limita-se à disponibilização das obras editoriais conforme contratado, não sendo
          responsável por:
        </p>
        <ul style={{marginLeft: '20px'}}>
          <li>indisponibilidade temporária</li>
          <li>falhas de conexão do usuário</li>
          <li>uso indevido por terceiros</li>
          <li>conteúdos, serviços ou condições ofertadas por parceiros</li>
        </ul>

        <h3>Cláusula IX – Proteção de Dados Pessoais</h3>
        <p>
          O tratamento de dados pessoais observará integralmente a Lei nº 13.709/2018 (LGPD).
        </p>
        <p>Os dados serão utilizados exclusivamente para:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>execução do contrato</li>
          <li>disponibilização das obras e funcionalidades</li>
          <li>melhoria da experiência do usuário</li>
        </ul>

        <h3>Cláusula X – Aceitação</h3>
        <p>Ao utilizar a plataforma, o usuário declara que:</p>
        <ul style={{marginLeft: '20px'}}>
          <li>leu</li>
          <li>compreendeu</li>
          <li>concorda integralmente com estes termos</li>
        </ul>

        <h3>Cláusula XI – Revista Digital de Conteúdo e Descontos</h3>
        <p>
          A plataforma poderá disponibilizar revistas digitais próprias ou de terceiros, incluindo publicações periódicas
          de conteúdo informativo, editorial e promocional, devidamente estruturadas como revistas e, quando aplicável,
          identificadas por ISSN.
        </p>
        <p>
          Tais revistas poderão conter informações sobre ofertas, descontos e vantagens junto a parceiros comerciais.
        </p>
        <p>
          O acesso a eventuais benefícios ou condições comerciais está vinculado às informações contidas nessas publicações,
          não se caracterizando como prestação de serviços de intermediação, mas sim como conteúdo editorial informativo.
        </p>
        <p>
          A PARTIU não se responsabiliza pelas condições comerciais, disponibilidade ou execução das ofertas divulgadas
          por terceiros.
        </p>

        <h3>Cláusula XII – Estrutura de Superapp e Integrações</h3>
        <p>
          A plataforma poderá ser disponibilizada em formato de aplicação integrada (superapp), personalizada para empresas
          clientes, podendo incluir diferentes módulos ou funcionalidades, conforme os produtos e serviços contratados por
          tais empresas.
        </p>
        <p>
          A disponibilização de conteúdos, obras editoriais e funcionalidades ao usuário final poderá ocorrer de forma
          automatizada, mediante integração com sistemas de terceiros, considerando critérios definidos pelas empresas
          contratantes, tais como planos, perfis ou categorias de usuários.
        </p>
        <p>
          A PARTIU atua exclusivamente como provedora da infraestrutura tecnológica para organização e disponibilização dos
          conteúdos e funcionalidades, não sendo responsável pelos serviços eventualmente oferecidos por terceiros dentro
          da plataforma.
        </p>

        <h3>Cláusula XIII – Legislação e Foro</h3>
        <p>
          Este Termo será regido pelas leis vigentes no Brasil.
        </p>
        <p>
          Fica eleito o foro da comarca da Barra da Tijuca, na cidade do Rio de Janeiro/RJ, com renúncia a qualquer outro,
          por mais privilegiado que seja.
        </p>
      </VStack>
    </Flex>
  );
}

export default TermsOfUse;
